
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ps",
      function () {
        return require("private-next-pages/ps/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ps"])
      });
    }
  